/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    V1LocalObjectReference,
    V1LocalObjectReferenceFromJSON,
    V1LocalObjectReferenceFromJSONTyped,
    V1LocalObjectReferenceToJSON,
} from './V1LocalObjectReference';

/**
 * FlexVolume represents a generic volume resource that is
 * provisioned/attached using an exec based plugin.
 * @export
 * @interface V1FlexVolumeSource
 */
export interface V1FlexVolumeSource {
    /**
     * driver is the name of the driver to use for this volume.
     * @type {string}
     * @memberof V1FlexVolumeSource
     */
    driver?: string;
    /**
     * fsType is the filesystem type to mount.
     * Must be a filesystem type supported by the host operating system.
     * Ex. "ext4", "xfs", "ntfs". The default filesystem depends on FlexVolume script.
     * +optional
     * @type {string}
     * @memberof V1FlexVolumeSource
     */
    fsType?: string;
    /**
     * options is Optional: this field holds extra command options if any.
     * +optional
     * @type {{ [key: string]: string; }}
     * @memberof V1FlexVolumeSource
     */
    options?: { [key: string]: string; };
    /**
     * readOnly is Optional: defaults to false (read/write). ReadOnly here will force
     * the ReadOnly setting in VolumeMounts.
     * +optional
     * @type {boolean}
     * @memberof V1FlexVolumeSource
     */
    readOnly?: boolean;
    /**
     * 
     * @type {V1LocalObjectReference}
     * @memberof V1FlexVolumeSource
     */
    secretRef?: V1LocalObjectReference;
}

export function V1FlexVolumeSourceFromJSON(json: any): V1FlexVolumeSource {
    return V1FlexVolumeSourceFromJSONTyped(json, false);
}

export function V1FlexVolumeSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1FlexVolumeSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driver': !exists(json, 'driver') ? undefined : json['driver'],
        'fsType': !exists(json, 'fsType') ? undefined : json['fsType'],
        'options': !exists(json, 'options') ? undefined : json['options'],
        'readOnly': !exists(json, 'readOnly') ? undefined : json['readOnly'],
        'secretRef': !exists(json, 'secretRef') ? undefined : V1LocalObjectReferenceFromJSON(json['secretRef']),
    };
}

export function V1FlexVolumeSourceToJSON(value?: V1FlexVolumeSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver': value.driver,
        'fsType': value.fsType,
        'options': value.options,
        'readOnly': value.readOnly,
        'secretRef': V1LocalObjectReferenceToJSON(value.secretRef),
    };
}

